import API from '../dataApi';

export const getUserPreferences = () => API.get('/preferences');
export const updateUserPreferences = (data) => API.put('/preferences', data);
export const updateUserTheme = (theme) => API.put('/preferences', { theme });
